// routes.js
import TripList from "@/components/trip/TripList.vue";
import DriverForm from "@/components/driver/DriverForm.vue";
import PassengerForm from "@/components/passenger/PassengerForm.vue";
import VehicleList from "@/components/vehicle/VehicleList.vue";
import VehicleForm from "@/components/vehicle/VehicleForm.vue";

const routes = [
  { path: "/expan-ussd-frontend/trips", component: TripList },
  { path: "/expan-ussd-frontend/vehicles", component: VehicleList },
  { path: "/expan-ussd-frontend/vehicle", component: VehicleForm },
  { path: "/expan-ussd-frontend/driver", component: DriverForm },
  { path: "/expan-ussd-frontend/passenger", component: PassengerForm },
];

export default routes;
